import { useContext, useEffect, useRef, useState } from 'react';
import { DialogContext } from '../../context/DialogContext';
import { TestingHqContext } from '../../context/TestingHqContext';
import List from '../../components/list/List';
import ImageView from '../image_view';
import PlaceJoin from './join';
import { get_place_list } from '../../utils/restapi';
import './list.css';

const PlaceList = () => {
  const { testingHqs } = useContext(TestingHqContext);
  const { openDialog, closeDialog } = useContext(DialogContext);
  const listRef = useRef(null);
  const [isDataReady, setIsDataReady] = useState(false);
  const [selectedGcode, setSelectedGcode] = useState('');

  // testingHqs 구조 확인 및 데이터 준비 상태 설정
  useEffect(() => {
    console.log('testingHqs:', testingHqs);
    console.log('testingHqs type:', typeof testingHqs);
    console.log('testingHqs is array:', Array.isArray(testingHqs));
    
    if (Array.isArray(testingHqs) && testingHqs.length > 0) {
      console.log('첫 번째 요소:', testingHqs[0]);
      console.log('첫 번째 요소의 keys:', Object.keys(testingHqs[0]));
      console.log('첫 번째 요소의 code:', testingHqs[0].code);
      setIsDataReady(true);
    } else {
      setIsDataReady(false);
    }
  }, [testingHqs]);

  // testingHqs 데이터가 준비되면 List 컴포넌트 새로고침
  useEffect(() => {
    if (isDataReady && listRef.current) {
      console.log('testingHqs 데이터가 준비되어 List를 새로고침합니다.');
      listRef.current.refresh();
    }
  }, [isDataReady]);

  // List에서 사용할 데이터 가져오기 함수
  const handleGetData = async (params) => {
    console.log('handleGetData 호출됨, testingHqs:', testingHqs);
    
    // testingHqs가 빈 배열이거나 undefined인 경우 처리
    if (!testingHqs || !Array.isArray(testingHqs) || testingHqs.length === 0) {
      console.warn('testingHqs가 비어있거나 배열이 아닙니다:', testingHqs);
      return { lists: [], total: 0, totalPages: 0 };
    }

    const requestParams = {
      gcodes: selectedGcode || testingHqs.map(hq => hq.code).join(','),
      ...params
    };

    console.log("handleGetData requestParams:", requestParams);
    return await get_place_list(requestParams);
  };

  const handleTestingHqChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedGcode(selectedValue);

    if (listRef.current) {
      listRef.current.resetItems();
      listRef.current.refresh();
    }
  };

  // 약도 이미지 다이얼로그 열기
  const handleMapClick = (item) => {
    const mapUrl = `https://www.klata.or.kr${item.map.url}`;
    const title = `${item.name} 약도`;

    const customStyles = {
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
      },
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '0',
        border: 'none',
        borderRadius: '8px',
        maxWidth: '100vw',
        maxHeight: '100vh',
        overflow: 'auto'
      },
    };

    openDialog(
      <ImageView 
        title={title}
        url={mapUrl}
        onClose={closeDialog}
      />, 
      customStyles
    );
  };

  // 정보수정 다이얼로그 열기
  const handleJoinClick = () => {
    const customStyles = {
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      },
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '0',
        border: 'none',
        borderRadius: '8px',
        maxWidth: '100vw',
        maxHeight: '100vh',
        overflow: 'auto'
      },
    };

    const handleClose = () => {
      closeDialog();
      // 다이얼로그 닫힌 후 목록 새로고침
      if (listRef.current) {
        listRef.current.refresh();
      }
    };

    openDialog(
      <PlaceJoin
        title={`고사장 등록`}
        placeObj={null}
        onClose={handleClose}
      />, 
      customStyles
    );
  };

  // headers에 renderCell 함수를 포함시킴
  const headers = [
    { 
      name: 'NO.', 
      value: 'a_place_id',
      renderCell: (item) => item.place_id
    },
    { 
      name: '지역본부', 
      value: 'a_gcode',
      renderCell: (item) => item.gcode
    },
    { 
      name: '장소코드', 
      value: 'a_code',
      renderCell: (item) => item.code
    },
    { 
      name: '장소명칭', 
      value: 'a_name',
      renderCell: (item) => item.name
    },
    { 
      name: '주소', 
      value: 'a_addressMain',
      renderCell: (item) => `${item.addressMain} ${item.addressDetail}`
    },
    { 
      name: '약도', 
      value: '',
      renderCell: (item) => item.map ? (
        <button 
          onClick={() => handleMapClick(item)}
          style={{ 
            background: 'none', 
            border: 'none', 
            color: '#007bff', 
            textDecoration: 'underline', 
            cursor: 'pointer' 
          }}
        >
          약도
        </button>
      ) : console.log(item)
    },
    { 
      name: '등록일', 
      value: 'a_regDate',
      renderCell: (item) => item.regDate
    }
  ];

  // buttons 정의 - listRef에서 선택된 항목 가져오기
  const buttons = [
    {
      text: '등록',
      onClick: handleJoinClick,
    }
  ];

  const handleRowClick = (item) => {
    // 행 클릭 시 동작할 내용 (예: 상세 정보 보기)
    console.log('Row clicked:', item);
  };

  // testingHqs 데이터가 준비되지 않으면 로딩 표시
  if (!isDataReady) {
    return (
      <div id="place_list">
        <div className="head">
          <h1>고사장 목록</h1>
        </div>
        <div className="body">
          <div className="middle">
            <div style={{ textAlign: 'center', padding: '50px' }}>
              데이터를 불러오는 중...
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div id="place_list">
      <div className="head">
        <h1>고사장 목록</h1>
      </div>
      <div className="body">
        <div className="top">
          <ul className="form">
            <li>
              <label>지역본부</label>
              <span>
                <select value={selectedGcode} onChange={handleTestingHqChange}>
                  <option value="">▒ 전체 ▒</option>
                  {testingHqs.map((hq, index) => (
                    <option key={index} value={hq.code}>
                      {hq.name}
                    </option>
                  ))}
                </select>
              </span>
            </li>
          </ul>
        </div>
        <div className="middle">
          <List
            ref={listRef}
            headers={headers}
            buttons={buttons}
            onGetData={handleGetData}
            onRowClick={handleRowClick}
            className="place_table"
            initialSort="a_place_id"
            initialDesc="desc"
            initialRowsPerPage={20}
          />
        </div>
        <div className="bottom">
        </div>
      </div>
    </div>
  );
};

export default PlaceList;
